module.exports = __webpack_public_path__ + "static/media/logo-mdesigner.d59ddae1.svg";